import React from "react";
import { Layout, Modal, Tooltip, Button, Typography, Table } from "antd";
import { listEmployeeScheduling } from "../../../api/server";
import { CloseOutlined } from "@ant-design/icons";
import { useIntl } from "react-intl";
import Date from "../../../components/tables/Date";
import Patient from "../../../components/tables/Patient";
import { getFullName } from "../../../components/util/helpers";
import { useQuery } from "react-query";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import moment from "moment";

const { Text } = Typography;

const SchedulingModal = (props) => {
  const { patientSchedulingRecord, closePatientSchedulingModal, scopePrefix } =
    props;
  const intl = useIntl();
  let { branchId } = useParams();

  const date = patientSchedulingRecord
    ? moment().set("year", patientSchedulingRecord.year)
    : moment();
  if (patientSchedulingRecord) {
    date.set("month", patientSchedulingRecord.month - 1);
  }

  const activeEmployee = useSelector(
    (state) => state.employeeDetails.activeEmployee
  );
  const page = {
    filter: {
      date: {
        $gt: date.startOf("month").format(),
        $lt: date.endOf("month").format(),
      },
    },
  };
  const { isLoading, data } = useQuery(
    [page, scopePrefix, activeEmployee],
    async () => {
      const params = {
        ...page,
        scopePrefix,
        employeeId: activeEmployee.id,
        branchId,
      };
      const result = await listEmployeeScheduling(params);
      const ordersIds = result.data.effective_orders
        .filter(
          (i) =>
            i.client_id === patientSchedulingRecord.client_id &&
            i.patient_id === patientSchedulingRecord.patient_id
        )
        .map((k) => k.id);
      const filtered = result.data.items.filter((i) =>
        ordersIds.includes(i.order_id)
      );
      return filtered;
    },
    {
      keepPreviousData: true,
      staleTime: 0,
      enabled:
        patientSchedulingRecord !== null &&
        activeEmployee &&
        activeEmployee.id !== undefined &&
        scopePrefix !== null,
    }
  );

  const columns = [
    {
      title: intl.formatMessage({
        id: "app.scheduling.patientName",
      }),
      dataIndex: "patient",
      render(text, record) {
        return (
          <Patient
            record={{
              id: patientSchedulingRecord.patient_id,
              branch: patientSchedulingRecord.branchId,
              first_name: patientSchedulingRecord.patient_first_name,
              surename: patientSchedulingRecord.patient_surename,
            }}
          />
        );
      },
      width: "220px",
    },
    {
      title: intl.formatMessage({
        id: "app.scheduling.date",
      }),
      dataIndex: "date",
      render(text) {
        return <Date text={text} format={"L"} />;
      },
    },
    {
      title: intl.formatMessage({
        id: "app.scheduling.dayInWeek",
      }),
      dataIndex: "date",
      render(text, record) {
        return <Text>{moment.weekdays(moment(text).weekday())}</Text>;
      },
    },
    {
      title: intl.formatMessage({
        id: "app.scheduling.start",
      }),
      dataIndex: "date",
      render(text) {
        return <Date text={text} format={"HH:mm"} />;
      },
      // width: "140px",
    },
    {
      title: intl.formatMessage({
        id: "app.scheduling.end",
      }),
      dataIndex: "date",
      render(text, record) {
        return (
          <Date
            text={moment(text).add(record.duration_minutes, "minutes")}
            format={"HH:mm"}
          />
        );
      },
    },
  ];

  return (
    <Modal
      width={"vw"}
      style={{
        height: "80vh",
        maxWidth: "80vw",
        position: "absolute",
        top: "10vh",
        left: "10vw",
      }}
      closable={false}
      open={patientSchedulingRecord !== null}
      footer={null}
      destroyOnClose={true}
    >
      <Layout
        style={{
          background: "transparent",
          paddingTop: "20px",
        }}
      >
        <Tooltip title="close">
          <Button
            onClick={closePatientSchedulingModal}
            size="large"
            style={{ position: "absolute", right: 10, top: 10 }}
            shape="circle"
            icon={<CloseOutlined />}
          />
        </Tooltip>
        <div style={{ marginTop: "20px" }}>
          {patientSchedulingRecord && (
            <Text>
              {`${intl.formatMessage({
                id: "app.scheduling.employeeScheduling",
              })}`}
              <span style={{ fontWeight: "bold" }}>{` ${getFullName(
                activeEmployee.surename,
                activeEmployee.first_name
              )} `}</span>
              {`${intl.formatMessage({
                id: "app.scheduling.ofPatient",
              })}`}
              <span style={{ fontWeight: "bold" }}>{` ${getFullName(
                patientSchedulingRecord.patient_surename,
                patientSchedulingRecord.patient_first_name
              )}`}</span>
              {` ${intl.formatMessage({
                id: "app.scheduling.inMonth",
              })}`}
              <span
                style={{ fontWeight: "bold" }}
              >{` ${patientSchedulingRecord.month}/${patientSchedulingRecord.year}`}</span>
            </Text>
          )}

          <Table
            bordered
            dataSource={data || []}
            columns={columns}
            pagination={false}
            scroll={{
              y: window.innerHeight * 0.8 - 160,
            }}
            loading={isLoading}
          />
        </div>
      </Layout>
    </Modal>
  );
};

export default SchedulingModal;
